<template>
  <div class="cover-box">
    <div class="box-type">背景图</div>
    <el-upload
      ref="uploader"
      action="#"
      list-type="picture-card"
      accept=".png,.jpg"
      :class="[
        'bg-uploader',
        mediaItem.bgIcon ? 'exist-img' : '',
        uploadStatus === 'uploading' ? 'uploading' : '',
        disabled ? 'is-disabled' : ''
      ]"
      :disabled="disabled"
      :limit="1"
      :file-list="fileList"
      :http-request="uploadFile"
      :before-upload="beforeUploadFile"
    >
      <div slot="file" class="cover-image-box">
        <el-image v-if="mediaItem.bgIcon" :src="mediaItem.bgIcon" fit="contain">
          <div slot="error" class="error-icon">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <span class="el-upload-list__item-actions" :style="uploadStatus === 'uploading' ? 'opacity:1' : ''">
          <span v-if="uploadStatus === 'success'" class="el-upload-list__item-delete" @click="removeFile">
            <i class="el-icon-delete"></i>
          </span>
          <span v-if="uploadStatus === 'success'" class="el-upload-list__item-delete" @click="handleReUpload">
            <i class="el-icon-upload" style="font-size:22px"></i>
          </span>
          <el-progress
            v-if="uploadStatus === 'uploading'"
            type="circle"
            color="#f78400"
            text-color="#fff"
            :width="100"
            :percentage="uploadPercent"
          ></el-progress>
        </span>
      </div>
      <div slot="default" class="cover-upload-btn">
        <i class="el-icon el-icon-plus"></i>
        <p v-html="bgImageConfig.fileTips"></p>
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    mediaItem: { type: Object },
    bgImageConfig: { type: Object },
    spaceId: { type: Number },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      uploadStatus: 'none',
      uploadPercent: 0,
      fileList: []
    }
  },
  mounted() {
    if (this.mediaItem.bgIcon && this.fileList.length === 0) {
      this.fileList = [{ bgIcon: this.mediaItem.bgIcon }]
      this.uploadStatus = 'success'
    }
  },
  methods: {
    beforeUploadFile(file) {
      let index = file.type.indexOf('/')
      let format = file.type.substring(index + 1)
      if (!['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG'].includes(format)) {
        this.$message.error(`图片只能是png/jpg格式`)
        return false
      }
    },
    uploadFile(paramsFile) {
      const self = this
      let fileReader = new FileReader()
      let dataFile = paramsFile.file

      this.uploadPercent = 0
      this.uploadStatus = 'uploading'
      this.mediaItem.bgIcon = ''
      fileReader.readAsBinaryString(dataFile)
      fileReader.onload = function (e) {
        const intervalId = setInterval(() => {
          self.uploadPercent < 99 && (self.uploadPercent += 5)
        }, 1560)
        let form = new FormData()
        form.append('file', dataFile)
        form.append('spaceId', self.spaceId)
        self.$service
          .uploadBgImage(form)
          .then(data => {
            self.uploadPercent = 100
            setTimeout(() => {
              self.uploadStatus = 'success'
              self.mediaItem.bgIcon = data
              window.clearInterval(intervalId)
            }, 300)
          })
          .catch(e => {
            self.uploadPercent = 0
            window.clearInterval(intervalId)
            self.uploadStatus = 'none'
            self.mediaItem.bgIcon = ''
            self.$refs.uploader.clearFiles()
            self.$message.error(e.message)
          })
      }
    },
    removeFile() {
      this.mediaItem.bgIcon = ''
      this.$refs.uploader.clearFiles()
      this.uploadStatus = 'none'
      this.uploadPercent = 0
    },
    handleReUpload() {
      const uploadRef = this.$refs.uploader
      if (uploadRef) {
        this.removeFile()
        uploadRef.$refs['upload-inner'].$refs.input.click()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.cover-box
  position relative
  box-sizing border-box
  padding 28px 10px 10px
  border 1px solid #c0ccda
  border-radius 4px
  width 268px
  .bg-uploader
    width 248px
    height 194px
    >>>div.el-upload.el-upload--picture-card
      padding 0
      width 248px
      height 194px
    >>>.el-upload-list
      height
    >>>.el-upload-list__item
      width 248px!important
      height 194px!important
      border none
      border-radius 0
    &.is-disabled >>>.el-upload-list__item-actions
      display none
    &.exist-img >>>div.el-upload.el-upload--picture-card
      display none
    &.uploading >>>div.el-upload.el-upload--picture-card
      display none
.cover-image-box
  display flex
  position relative
  flex-grow 1
  height 148px
  .el-image
    width 248px
    height 138px
    padding 0
    .error-icon
      display flex
      justify-content center
      align-items center
      height 100%
.el-upload-list__item-actions
  border 0
  height 138px
  .el-progress
    width 100px
    >>>.el-progress__text
      color #fff
.el-upload-list__item-delete
  margin 0 12px
  &:hover
    color #f78400
.cover-upload-btn
  display flex
  flex-flow column nowrap
  justify-content center
  border-radius 6px
  height 185px
  line-height 22px
  font-size 12px
  color #999
  background-color #fff
  .el-icon
    color #f78400
  p
    margin 4px 0
    word-break break-all
.box-type
  position absolute
  top 0
  left 0
  width 60px
  height 18px
  line-height 18px
  text-align center
  font-size 12px
  color #fff
  background-color #f78400
  border-radius 4px 0
</style>
